import React from 'react'

import Button from '../Button'

import './GetStarted.css'

const GetStarted = props => {
  const { style } = props

  return (
    <div className={'cookunity__get_started small'} style={style}>
      <p className="content">
        Subscribe now and
        <br />
        <span className="discount">save up to 30%</span> on the
        <br />
        price of each meal
      </p>
      <Button>Get Started</Button>

      <div className="background" />
    </div>
  )
}

export default GetStarted



// WEBPACK FOOTER //
// ./src/components/GetStarted/GetStarted.jsx